/** Green chroma-key style preset offered in the face color popover. */
export const WALL_COLOR_PRESET_GREEN = "#00B140"

export function normalizeHex(hex: string): string {
  const raw = hex.trim()
  if (/^#[0-9a-fA-F]{6}$/.test(raw)) return raw.toLowerCase()
  if (/^#[0-9a-fA-F]{3}$/.test(raw)) {
    const r = raw[1]!
    const g = raw[2]!
    const b = raw[3]!
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase()
  }
  throw new Error(`Invalid color: ${hex}`)
}
